import React from "react";
import { CheckCircle2, Square } from "lucide-react";

export default function ScheduleListItem({
  getDepartmentColor,
  onOpenDetail,
  onToggleComplete,
  schedule,
  selectedDepartment,
  theme,
}) {
  return (
    <div
      onClick={() => onOpenDetail(schedule)}
      className={`p-4 rounded-2xl border transition cursor-pointer hover:shadow-md hover:-translate-y-0.5 group relative bg-white flex-shrink-0 ${schedule.isCompleted ? "opacity-60 grayscale" : "border-gray-100"}`}
    >
      <div className={`absolute left-0 top-4 bottom-4 w-1 rounded-r-full ${schedule.type === "worship" ? "bg-purple-500" : schedule.type === "event" ? "bg-orange-500" : `${theme.bg}`}`}></div>
      <div className="pl-3">
        <div className="flex justify-between items-start mb-1">
          <div className="font-bold text-gray-800 text-sm line-clamp-1">
            {selectedDepartment === "All" && (
              <span className={`text-xs text-white px-2 py-0.5 rounded mr-2 align-middle shadow-sm ${getDepartmentColor(schedule.department || "All")}`}>
                {schedule.department === "All" || !schedule.department ? "전체" : schedule.department}
              </span>
            )}
            {schedule.title}
          </div>
          <div onClick={(event) => onToggleComplete(event, schedule)} className={`cursor-pointer ${schedule.isCompleted ? `${theme.text}` : `text-gray-300 hover:${theme.text}`}`}>
            {schedule.isCompleted ? <CheckCircle2 size={16} /> : <Square size={16} />}
          </div>
        </div>
        <div className="text-xs text-gray-400 font-medium flex items-center gap-2">
          <span>{schedule.startTime || "하루 종일"} ~ {schedule.endTime}</span>
          {schedule.priority === "high" && <span className="text-red-500 font-bold">! 긴급</span>}
        </div>
      </div>
    </div>
  );
}
